export type Severity  = "info" | "success" | "warning" | "error";

import { CommonModule } from '@angular/common';
import {
	Component, Input
} from '@angular/core';


/***
 * Note a CSS defenition of display block is applied to the component element so in default state it will
 * take the full width of its parent container.
 * In client code  you can place it near other elements in a row using flexbox container, use CSS grid etc
 * You can  alternatively  use position absolute with position  properties (top,left etc/) to position the element
 *
 * Applay z-index if required
 *
 * Use the type input property with one of the folowing values : "info" , "success" , "warning" , "error" defaults to "info"
 *
 * the client code can embed the data required for the text message between the element's tags
 *
 * Examples :<br>
 * 1.<cp-inline-notification [type]="'warning'" style="position: absolute;top:50px;left:50px;">
 * 			<label>{{'NoStudyProcedureSelected' | cpMessageTranslate}}</label></cp-inline-notification>
 *
 * 2.<cp-inline-notification [type]="'info'">
 * 					{{'NoScanDocsIndication'|cpMessageTranslate}}</cp-inline-notification>
 *
 * 3.<cp-inline-notification [type]="'warning'">
 * 		{{"DocumentNotFrom" | cpMessageTranslate}}&nbsp;
 * 		<span (click)="current.emit(true)" class="current-order">{{"CurrentOrder" | cpActionTranslate}}
 * 		</span>
 * 	</cp-inline-notification>
 */


@Component({
	selector: 'cp-inline-notification',
	templateUrl: './inline.notification.template.html',
	standalone:true,
	imports:[CommonModule],
	styleUrls: ['./inline.notification.style.scss']
})
export class InlineNotificationComponent {
	// @ts-ignore
	@Input() type:Severity='info';
	/*@Input() borderSize: string;*/
	constructor() {
	}

}
